import { UserRoles } from "./users";

export type UsernamePasswordCredentials = {
  username: string;
  password: string;
};

export type RefreshToken = {
  refresh: string;
};

export type AuthResponse = {
  access: string;
  refresh: string;
  role: UserRoles;
};

export type OtpResponse = {
  detail: string;
};

export type PhoneCredentials = {
  phone: string;
};

export type OTPCredentials = {
  phone: string;
  otp_code: string;
};

export enum AuthType {
  PHONE = "phone",
  LOGIN = "login",
}
